export const VIEW_MODE = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
} as const;

export type ViewMode = (typeof VIEW_MODE)[keyof typeof VIEW_MODE];
